import { render, staticRenderFns } from "./BuildWorkout.vue?vue&type=template&id=49d5d730&scoped=true&"
import script from "./BuildWorkout.vue?vue&type=script&lang=js&"
export * from "./BuildWorkout.vue?vue&type=script&lang=js&"
import style0 from "./BuildWorkout.vue?vue&type=style&index=0&id=49d5d730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d5d730",
  null
  
)

export default component.exports